import { styleOverrides } from "./styleOverrides";

const MuiTabPanel = {
  styleOverrides,
};

export { MuiTabPanel };
